export default "__VITE_ASSET__e5d599bd__"